export const SEIKUYFORDATASOURCE = [
  {  
    name: "提供明細",
    table: "1",
    calcfunc: 0,
    fieldname: "field",
    fields: [
      {
        field: "ROWTYPE",
        displayName: "行区分",
        dataType: "VARCHAR"
      },
      {
        field: "DAICD",
        displayName: "対象者コード",
        dataType: "VARCHAR"
      },
      {
        field: "KANANAME",
        displayName: "対象者ｶﾅ",
        dataType: "VARCHAR"
      },
      {
        field: "NAME",
        displayName: "対象者名称",
        dataType: "VARCHAR"
      },
      {
        field: "HHCD",
        displayName: "被保険者番号",
        dataType: "VARCHAR"
      },
      {
        field: "HOCD",
        displayName: "保険者番号",
        dataType: "VARCHAR"
      },
      {
        field: "HONM",
        displayName: "保険者名",
        dataType: "VARCHAR"
      },
      {
        field: "GKLV",
        displayName: "介護度",
        dataType: "VARCHAR"
      },
      {
        field: "GENDER",
        displayName: "性別",
        dataType: "VARCHAR"
      },
      {
        field: "SRVSDATE",
        displayName: "サービス提供月",
        dataType: "DATETIME"
      },
      {
        field: "RECEDATEKOKUHO",
        displayName: "国保請求月",
        dataType: "DATETIME"
      },
      {
        field: "RECEDATEKOJIN",
        displayName: "個人請求月",
        dataType: "DATETIME"
      },
      {
        field: "JSRVKBNCD",
        displayName: "種別",
        dataType: "VARCHAR"
      },
      {
        field: "JIGCD",
        displayName: "事業所コード",
        dataType: "VARCHAR"
      },
      {
        field: "SHITEI",
        displayName: "指定",
        dataType: "VARCHAR"
      },
      {
        field: "JIGNM",
        displayName: "事業所名",
        dataType: "VARCHAR"
      },
      {
        field: "SDATE",
        displayName: "日付",
        dataType: "DATETIME"
      },
      {
        field: "STIME",
        displayName: "開始",
        dataType: "DATETIME"
      },
      {
        field: "ETIME",
        displayName: "終了",
        dataType: "DATETIME"
      },
      {
        field: "KINDNM",
        displayName: "サービス種別",
        dataType: "VARCHAR"
      },
      {
        field: "SRVCD",
        displayName: "コード",
        dataType: "VARCHAR"
      },
      {
        field: "SRVNM",
        displayName: "サービス内容",
        dataType: "VARCHAR"
      },
      {
        field: "KMKCD",
        displayName: "科目コード",
        dataType: "VARCHAR"
      },
      {
        field: "KMKNM",
        displayName: "科目名",
        dataType: "VARCHAR"
      },
      {
        field: "PRODUCTID",
        displayName: "商品コード",
        dataType: "VARCHAR"
      },
      {
        field: "TAISCD",
        displayName: "JAN/TAISコード",
        dataType: "VARCHAR"
      },
      {
        field: "PRODUCTNM",
        displayName: "商品名",
        dataType: "VARCHAR"
      },
      {
        field: "TYPE",
        displayName: "単位数識別記号",
        dataType: "VARCHAR"
      },
      {
        field: "TANISRC",
        displayName: "合成単位",
        dataType: "FLOAT"
      },
      {
        field: "DISCOUNT",
        displayName: "割引率％",
        dataType: "FLOAT"
      },
      {
        field: "BASEPAY",
        displayName: "基準額(円)",
        dataType: "FLOAT"
      },
      {
        field: "HOSOKSUMPRICE",
        displayName: "実際の費用",
        dataType: "FLOAT"
      },
      {
        field: "LIMITPAY",
        displayName: "負担限度(円)",
        dataType: "FLOAT"
      },
      {
        field: "TANIDST",
        displayName: "単位",
        dataType: "FLOAT"
      },
      {
        field: "COUNTSUM",
        displayName: "回数",
        dataType: "FLOAT"
      },
      {
        field: "TANISUM",
        displayName: "合計単位",
        dataType: "FLOAT"
      },
      {
        field: "PAYKBN",
        displayName: "請求方法",
        dataType: "VARCHAR"
      },
      {
        field: "INSURA",
        displayName: "給付率",
        dataType: "FLOAT"
      },
      {
        field: "KOUHI1",
        displayName: "第１公費",
        dataType: "FLOAT"
      },
      {
        field: "KOUHI2",
        displayName: "第２公費",
        dataType: "FLOAT"
      },
      {
        field: "KOUHI3",
        displayName: "第３公費",
        dataType: "FLOAT"
      },
      {
        field: "AREACOST",
        displayName: "地域単価",
        dataType: "FLOAT"
      },
      {
        field: "INSURSUM",
        displayName: "保険＋公費負担額",
        dataType: "FLOAT"
      },
      {
        field: "INSURAOWN",
        displayName: "保険分自己負担額",
        dataType: "FLOAT"
      },
      {
        field: "INSOUTOWN",
        displayName: "全額自己負担金額",
        dataType: "FLOAT"
      },
      {
        field: "___SFK",
        displayName: "社福軽減額",
        dataType: "FLOAT"
      },
      {
        field: "___JSI",
        displayName: "自治体独自助成等",
        dataType: "FLOAT"
      },
      {
        field: "___KOUGK",
        displayName: "高額介護サ費",
        dataType: "FLOAT"
      },
      {
        field: "MEDTARGET",
        displayName: "医療費控除対象額",
        dataType: "FLOAT"
      },
      {
        field: "___RIYOUPAY",
        displayName: "利用者請求額",
        dataType: "FLOAT"
      },
      {
        field: "SUMPRICE",
        displayName: "サービス費用総額",
        dataType: "FLOAT"
      },
      {
        field: "___ZEI",
        displayName: "消費税",
        dataType: "FLOAT"
      },
      {
        field: "HOSOKPAY",
        displayName: "補足給付(円)",
        dataType: "FLOAT"
      },
      {
        field: "SEIHOPAY",
        displayName: "生保支払(円)",
        dataType: "FLOAT"
      },
      {
        field: "FUKUSPAY",
        displayName: "福祉事務所(円)",
        dataType: "FLOAT"
      },
      {
        field: "HOSKOWN",
        displayName: "自己負担(円)",
        dataType: "FLOAT"
      },
      {
        field: "ADJUSTPAY",
        displayName: "調整額(円)",
        dataType: "FLOAT"
      },
      {
        field: "DAY1",
        displayName: "1日",
        dataType: "FLOAT"
      },
      {
        field: "DAY2",
        displayName: "2日",
        dataType: "FLOAT"
      },
      {
        field: "DAY3",
        displayName: "3日",
        dataType: "FLOAT"
      },
      {
        field: "DAY4",
        displayName: "4日",
        dataType: "FLOAT"
      },
      {
        field: "DAY5",
        displayName: "5日",
        dataType: "FLOAT"
      },
      {
        field: "DAY6",
        displayName: "6日",
        dataType: "FLOAT"
      },
      {
        field: "DAY7",
        displayName: "7日",
        dataType: "FLOAT"
      },
      {
        field: "DAY8",
        displayName: "8日",
        dataType: "FLOAT"
      },
      {
        field: "DAY9",
        displayName: "9日",
        dataType: "FLOAT"
      },
      {
        field: "DAY10",
        displayName: "10日",
        dataType: "FLOAT"
      },
      {
        field: "DAY11",
        displayName: "11日",
        dataType: "FLOAT"
      },
      {
        field: "DAY12",
        displayName: "12日",
        dataType: "FLOAT"
      },
      {
        field: "DAY13",
        displayName: "13日",
        dataType: "FLOAT"
      },
      {
        field: "DAY14",
        displayName: "14日",
        dataType: "FLOAT"
      },
      {
        field: "DAY15",
        displayName: "15日",
        dataType: "FLOAT"
      },
      {
        field: "DAY16",
        displayName: "16日",
        dataType: "FLOAT"
      },
      {
        field: "DAY17",
        displayName: "17日",
        dataType: "FLOAT"
      },
      {
        field: "DAY18",
        displayName: "18日",
        dataType: "FLOAT"
      },
      {
        field: "DAY19",
        displayName: "19日",
        dataType: "FLOAT"
      },
      {
        field: "DAY20",
        displayName: "20日",
        dataType: "FLOAT"
      },
      {
        field: "DAY21",
        displayName: "21日",
        dataType: "FLOAT"
      },
      {
        field: "DAY22",
        displayName: "22日",
        dataType: "FLOAT"
      },
      {
        field: "DAY23",
        displayName: "23日",
        dataType: "FLOAT"
      },
      {
        field: "DAY24",
        displayName: "24日",
        dataType: "FLOAT"
      },
      {
        field: "DAY25",
        displayName: "25日",
        dataType: "FLOAT"
      },
      {
        field: "DAY26",
        displayName: "26日",
        dataType: "FLOAT"
      },
      {
        field: "DAY27",
        displayName: "27日",
        dataType: "FLOAT"
      },
      {
        field: "DAY28",
        displayName: "28日",
        dataType: "FLOAT"
      },
      {
        field: "DAY29",
        displayName: "29日",
        dataType: "FLOAT"
      },
      {
        field: "DAY30",
        displayName: "30日",
        dataType: "FLOAT"
      },
      {
        field: "DAY31",
        displayName: "31日",
        dataType: "FLOAT"
      },
  
    ]
  },
  {  
    name: "提供明細（総合支援）",
    table: "2",
    calcfunc: 0,
    fieldname: "field",
    fields: [
      {
        field: "ROWTYPE",
        displayName: "行区分",
        dataType: "VARCHAR"
      },
      {
        field: "DAICD",
        displayName: "対象者コード",
        dataType: "VARCHAR"
      },
      {
        field: "KANANAME",
        displayName: "対象者ｶﾅ",
        dataType: "VARCHAR"
      },
      {
        field: "NAME",
        displayName: "対象者名称",
        dataType: "VARCHAR"
      },
      {
        field: "SJNO",
        displayName: "受給者証番号",
        dataType: "VARCHAR"
      },
      {
        field: "CITYCD",
        displayName: "市町村",
        dataType: "VARCHAR"
      },
      {
        field: "CITYNM",
        displayName: "市町村名",
        dataType: "VARCHAR"
      },
      {
        field: "SKBNCD1",
        displayName: "障害種別-身体障害",
        dataType: "VARCHAR"
      },
      {
        field: "SKBNCD2",
        displayName: "障害種別-知的障害",
        dataType: "VARCHAR"
      },
      {
        field: "SKBNCD3",
        displayName: "障害種別-障害児",
        dataType: "VARCHAR"
      },
      {
        field: "SKBNCD4",
        displayName: "障害種別-精神障害",
        dataType: "VARCHAR"
      },
      {
        field: "SKBNCD5",
        displayName: "障害種別-難病等",
        dataType: "VARCHAR"
      },
      {
        field: "GKLV",
        displayName: "区分",
        dataType: "VARCHAR"
      },
      {
        field: "GENDER",
        displayName: "性別",
        dataType: "VARCHAR"
      },
      {
        field: "SRVSDATE",
        displayName: "サービス提供月",
        dataType: "DATETIME"
      },
      {
        field: "RECEDATEKOKUHO",
        displayName: "国保請求月",
        dataType: "DATETIME"
      },
      {
        field: "RECEDATEKOJIN",
        displayName: "個人請求月",
        dataType: "DATETIME"
      },
      {
        field: "JSRVKBNCD",
        displayName: "種別",
        dataType: "VARCHAR"
      },
      {
        field: "JIGCD",
        displayName: "事業所コード",
        dataType: "VARCHAR"
      },
      {
        field: "SHITEI",
        displayName: "指定",
        dataType: "VARCHAR"
      },
      {
        field: "JIGNM",
        displayName: "事業所名",
        dataType: "VARCHAR"
      },
      {
        field: "SDATE",
        displayName: "日付",
        dataType: "DATETIME"
      },
      {
        field: "STIME",
        displayName: "開始",
        dataType: "DATETIME"
      },
      {
        field: "ETIME",
        displayName: "終了",
        dataType: "DATETIME"
      },
      {
        field: "KINDNM",
        displayName: "サービス種別",
        dataType: "VARCHAR"
      },
      {
        field: "SRVCD",
        displayName: "コード",
        dataType: "VARCHAR"
      },
      {
        field: "SRVNM",
        displayName: "サービス内容",
        dataType: "VARCHAR"
      },
      {
        field: "KMKCD",
        displayName: "科目コード",
        dataType: "VARCHAR"
      },
      {
        field: "KMKNM",
        displayName: "科目名",
        dataType: "VARCHAR"
      },
      {
        field: "TYPE",
        displayName: "単位数識別記号",
        dataType: "VARCHAR"
      },
      {
        field: "TANISRC",
        displayName: "合成単位",
        dataType: "FLOAT"
      },
      {
        field: "DISCOUNT",
        displayName: "割引率％",
        dataType: "FLOAT"
      },
      {
        field: "TANIDST",
        displayName: "単位",
        dataType: "FLOAT"
      },
      {
        field: "COUNTSUM",
        displayName: "回数",
        dataType: "FLOAT"
      },
      {
        field: "TANISUM",
        displayName: "合計単位",
        dataType: "FLOAT"
      },
      {
        field: "PAYKBN",
        displayName: "請求方法",
        dataType: "VARCHAR"
      },
      {
        field: "INSURA",
        displayName: "給付率",
        dataType: "FLOAT"
      },
      {
        field: "AREACOST",
        displayName: "単位数単価",
        dataType: "FLOAT"
      },
      {
        field: "INSURSUM",
        displayName: "給付額",
        dataType: "FLOAT"
      },
      {
        field: "INSURAOWN",
        displayName: "自己負担額",
        dataType: "FLOAT"
      },
      {
        field: "KEIGENGAKU",
        displayName: "軽減額",
        dataType: "FLOAT"
      },
      {
        field: "PROVCNT",
        displayName: "契約支給量",
        dataType: "VARCHAR"
      },
      {
        field: "INSOUTOWN",
        displayName: "全額自己負担金額",
        dataType: "FLOAT"
      },
      {
        field: "SUMPRICE",
        displayName: "総費用額",
        dataType: "FLOAT"
      },
      {
        field: "___ZEI",
        displayName: "消費税",
        dataType: "FLOAT"
      },
      {
        field: "SHOSKEAT1",
        displayName: "朝食",
        dataType: "FLOAT"
      },
      {
        field: "SHOSKEAT2",
        displayName: "昼食",
        dataType: "FLOAT"
      },
      {
        field: "SHOSKEAT3",
        displayName: "夕食",
        dataType: "FLOAT"
      },
      {
        field: "SHOSKEATA",
        displayName: "食費合計",
        dataType: "FLOAT"
      },
      {
        field: "SHOSKHEAT",
        displayName: "光熱水費",
        dataType: "FLOAT"
      },
      {
        field: "SHOSKHOUTS",
        displayName: "外部利用",
        dataType: "FLOAT"
      },
      {
        field: "SHOSKKYOJU",
        displayName: "家賃",
        dataType: "FLOAT"
      },
      {
        field: "SKNRJIG",
        displayName: "管理事所",
        dataType: "VARCHAR"
      },
      {
        field: "JIGSFK",
        displayName: "社福軽減",
        dataType: "FLOAT"
      },
      {
        field: "JIGSYUA",
        displayName: "Ａ型減免",
        dataType: "VARCHAR"
      },
      {
        field: "DAY1",
        displayName: "1日",
        dataType: "FLOAT"
      },
      {
        field: "DAY2",
        displayName: "2日",
        dataType: "FLOAT"
      },
      {
        field: "DAY3",
        displayName: "3日",
        dataType: "FLOAT"
      },
      {
        field: "DAY4",
        displayName: "4日",
        dataType: "FLOAT"
      },
      {
        field: "DAY5",
        displayName: "5日",
        dataType: "FLOAT"
      },
      {
        field: "DAY6",
        displayName: "6日",
        dataType: "FLOAT"
      },
      {
        field: "DAY7",
        displayName: "7日",
        dataType: "FLOAT"
      },
      {
        field: "DAY8",
        displayName: "8日",
        dataType: "FLOAT"
      },
      {
        field: "DAY9",
        displayName: "9日",
        dataType: "FLOAT"
      },
      {
        field: "DAY10",
        displayName: "10日",
        dataType: "FLOAT"
      },
      {
        field: "DAY11",
        displayName: "11日",
        dataType: "FLOAT"
      },
      {
        field: "DAY12",
        displayName: "12日",
        dataType: "FLOAT"
      },
      {
        field: "DAY13",
        displayName: "13日",
        dataType: "FLOAT"
      },
      {
        field: "DAY14",
        displayName: "14日",
        dataType: "FLOAT"
      },
      {
        field: "DAY15",
        displayName: "15日",
        dataType: "FLOAT"
      },
      {
        field: "DAY16",
        displayName: "16日",
        dataType: "FLOAT"
      },
      {
        field: "DAY17",
        displayName: "17日",
        dataType: "FLOAT"
      },
      {
        field: "DAY18",
        displayName: "18日",
        dataType: "FLOAT"
      },
      {
        field: "DAY19",
        displayName: "19日",
        dataType: "FLOAT"
      },
      {
        field: "DAY20",
        displayName: "20日",
        dataType: "FLOAT"
      },
      {
        field: "DAY21",
        displayName: "21日",
        dataType: "FLOAT"
      },
      {
        field: "DAY22",
        displayName: "22日",
        dataType: "FLOAT"
      },
      {
        field: "DAY23",
        displayName: "23日",
        dataType: "FLOAT"
      },
      {
        field: "DAY24",
        displayName: "24日",
        dataType: "FLOAT"
      },
      {
        field: "DAY25",
        displayName: "25日",
        dataType: "FLOAT"
      },
      {
        field: "DAY26",
        displayName: "26日",
        dataType: "FLOAT"
      },
      {
        field: "DAY27",
        displayName: "27日",
        dataType: "FLOAT"
      },
      {
        field: "DAY28",
        displayName: "28日",
        dataType: "FLOAT"
      },
      {
        field: "DAY29",
        displayName: "29日",
        dataType: "FLOAT"
      },
      {
        field: "DAY30",
        displayName: "30日",
        dataType: "FLOAT"
      },
      {
        field: "DAY31",
        displayName: "31日",
        dataType: "FLOAT"
      },
  
    ]
  }
]

export const SEIKYUU_TYPE  = [
  ["0", "1"],    // Type 1
  // ... defined more if needed
]